module.exports = __webpack_public_path__ + "static/img/232_TO8_1979.8484063.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/232_TO8_1979.jpg
// module id = xyGM
// module chunks = 0